export default __webpack_public_path__ + "static/media/af.cf87c249.svg";